// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"4eb4eb23","76":"7818aaca","219":"d531fbc3","258":"94c3c3a9","281":"bfdd2141","363":"57d0ee21","527":"a588ff74","788":"153ee096"}[chunkId] + ".chunk.js";
};